/**
 * Validation schemas для форм AdminOffice (Yup)
 */

import * as Yup from 'yup';

/**
 * Схема для реанимации заявки
 */
export const validApplicationIdSchema = Yup.object({
  applicationId: Yup.number()
    .required('ID заявки обязателен')
    .positive('ID должен быть положительным числом')
    .integer('ID должен быть целым числом'),
});

/**
 * Схема для создания платежа
 */
export const createPaymentSchema = Yup.object({
  sum: Yup.number()
    .required('Сумма обязательна')
    .positive('Сумма должна быть положительной'),
  date: Yup.string().required('Дата обязательна'),
});

/**
 * Схема для прямого поступления
 */
export const directReceiptSchema = Yup.object({
  sum: Yup.number()
    .required('Сумма обязательна')
    .positive('Сумма должна быть положительной'),
  date: Yup.string().required('Дата обязательна'),
  account: Yup.string().required('Счет обязателен'),
});

/**
 * Схема для обновления данных клиента
 */
export const updateClientDataSchema = Yup.object({
  firstName: Yup.string()
    .required('Имя обязательно')
    .min(2, 'Имя должно содержать минимум 2 символа'),
  lastName: Yup.string()
    .required('Фамилия обязательна')
    .min(2, 'Фамилия должна содержать минимум 2 символа'),
  middleName: Yup.string()
    .required('Отчество обязательно')
    .min(2, 'Отчество должно содержать минимум 2 символа'),
  birthDate: Yup.string().required('Дата рождения обязательна'),
  passportSeries: Yup.string()
    .required('Серия обязательна')
    .matches(/^\d{4}$/, 'Серия должна состоять из 4 цифр'),
  passportNumber: Yup.string()
    .required('Номер обязателен')
    .matches(/^\d{6}$/, 'Номер должен состоять из 6 цифр'),
  passportIssueDate: Yup.string().required('Дата выдачи обязательна'),
  passportIssueAuthority: Yup.string().required('Орган выдачи обязателен'),
  passportIssueLocation: Yup.string()
    .required('Код подразделения обязателен')
    .matches(/^\d{3}-\d{3}$/, 'Код должен быть в формате XXX-XXX'),
  mobilePhone: Yup.string()
    .required('Телефон обязателен')
    .matches(/^\+?\d{10,12}$/, 'Некорректный формат телефона'),
});

/**
 * Схема для загрузки среднедушевого дохода
 */
export const averageIncomeUploadSchema = Yup.object({
  quarter: Yup.string()
    .required('Квартал обязателен')
    .matches(/^[1-4]$/, 'Квартал должен быть от 1 до 4'),
  year: Yup.string()
    .required('Год обязателен')
    .matches(/^\d{4}$/, 'Год должен состоять из 4 цифр'),
});

/**
 * Схема для создания пользователя
 */
export const createUserSchema = Yup.object({
  login: Yup.string()
    .required('Логин обязателен')
    .min(3, 'Логин должен содержать минимум 3 символа')
    .max(50, 'Логин не должен превышать 50 символов'),
  password: Yup.string()
    .required('Пароль обязателен')
    .min(8, 'Пароль должен содержать минимум 8 символов')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Пароль должен содержать заглавные и строчные буквы, цифры'
    ),
  comment: Yup.string().max(200, 'Комментарий не должен превышать 200 символов'),
});

/**
 * Схема для генерации документов
 */
export const generateDocumentSchema = Yup.object({
  applicationId: Yup.number()
    .required('ID заявки обязателен')
    .positive('ID должен быть положительным числом')
    .integer('ID должен быть целым числом'),
  genDate: Yup.string().required('Дата генерации обязательна'),
  tosave: Yup.boolean(),
  sendToMyMfo: Yup.boolean(),
});

/**
 * Схема для поиска клиента
 */
export const clientSearchSchema = Yup.object({
  lastname: Yup.string().nullable(),
  firstname: Yup.string().nullable(),
  middlename: Yup.string().nullable(),
  series: Yup.string()
    .nullable()
    .matches(/^\d{4}$|^$/, 'Серия должна состоять из 4 цифр'),
  number: Yup.string()
    .nullable()
    .matches(/^\d{6}$|^$/, 'Номер должен состоять из 6 цифр'),
});
